<template>
    <div class='body'>
        <div class='search-box' v-if='org == 1'>
            <div>
                <span class='title'>院校名称：</span>
                <el-input class='search-input' v-model='listQuery.content' placeholder='请输入院校名称/院校代码' clearable
                          @change='handleSearch'></el-input>
                <span class='title'>合作类别：</span>
                <el-select class='search-input' v-model='listQuery.purpose' @change='handleSearch' >
                    <el-option v-for='item in purpose' :key='item.value' :value='item.value'
                               :label='item.label'></el-option>
                </el-select>
                <span class='title'>合作机构：</span>
                <el-input class='search-input' v-model='listQuery.organization' placeholder='请输入合作机构' clearable
                          @change='handleSearch'></el-input>
                <span class='title'>商务负责人：</span>
                <el-input class='search-input' v-model='listQuery.person' placeholder='请输入商务负责人' clearable
                          @change='handleSearch'></el-input>
            </div>
            <div class='margin-left-30'>
                <el-button class='primary-btn' @click='reset()'>重置</el-button>
                <el-button type='primary' style='margin-left: 16px' @click='handleSearch()'>查询</el-button>
            </div>
        </div>

        <div class='container'>
            <div class='handle-box' v-if='org == 1'>
                <el-button
                    type='primary'
                    icon='el-icon-circle-plus-outline'
                    class='handle-del mr10'
                    @click="judgeBtn('add')"
                >添加院校
                </el-button>
                <el-button
                    type='primary'
                    class='handle-del mr10'
                    @click='openProcess' plain
                >查看进度
                </el-button>

            </div>

            <div class='table-cls'>
                <el-table
                    :data='tableData'
                    border
                    class='table'
                    :cell-style="{color:'#666666',fontSize:'14px'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500,fontSize:'14px'}"
                >
                    <el-table-column prop='org' align='center' label='院校ID'></el-table-column>
                    <el-table-column prop='org_name' align='center' label='院校名称'></el-table-column>
                    <el-table-column prop='purpose' align='center' label='合作类别'>
                        <template slot-scope='scope'>
                            {{ purposeHash[scope.row.purpose] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop='organization' align='center' label='合作机构'v-if='org == 1'></el-table-column>
                    <el-table-column prop='contact' align='center' label='合作联系人'v-if='org == 1'></el-table-column>
                    <el-table-column prop='group_name' align='center' label='对接群名称'v-if='org == 1'></el-table-column>
                    <el-table-column prop='person' align='center' label='商务负责人'v-if='org == 1'></el-table-column>
                    <el-table-column prop='PreStudent_count' align='center' label='考前学生人数'></el-table-column>
                    <el-table-column prop='StudentCount' align='center' label='考后学生人数'></el-table-column>
                    <el-table-column prop='' align='center' label='总人数'>
                        <template slot-scope='scope'>
                            {{ scope.row.PreStudent_count + scope.row.StudentCount }}
                        </template>
                    </el-table-column>
                    <el-table-column prop='valid_end_time' align='center' label='合作截止日期' v-if='org == 1'></el-table-column>

                    <el-table-column label='操作' width='500px' align='center' fixed='right'>
                        <template slot-scope='scope'>
                            <el-button
                                class='primary-btn'
                                @click="judgeBtn('edit',scope.row)"
                            >编辑
                            </el-button>
                            <el-button
                                class='primary-btn'
                                @click='open()'
                                style='margin-left: 16px'
                                v-if='org == 1'
                            >配置学籍模板
                            </el-button>
                            <el-button
                                class='primary-btn'
                                @click='openWeightDialog(scope.row)'
                                style='margin-left: 16px'

                            >权重
                            </el-button>
                            <el-button
                                class='primary-btn'
                                @click='addInfo(scope.row.org)'
                                v-if='org == 1'
                            >添加测试账号
                            </el-button>
                            <el-button
                                type='danger'
                                @click='del(scope.row.id)'
                                style='margin-left: 16px'
                                v-if='org == 1'
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page=listQuery.pageIndex
                    :page-size=10
                    :total=listQuery.pageTotal
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>

        <!-- dialog弹出框 -->
        <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='440px'
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <el-form ref='form' :model='form' :rules='rules' label-width='auto' >
                <el-form-item label='院校ID：' prop='org' v-if='org == 1'>
                    <el-input-number v-model='form.org' :min='1' label='院校ID' style='width: 240px'></el-input-number>
                </el-form-item>
                <el-form-item label='院校代码：' prop='org_code'>
                    <el-input v-model='form.org_code' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item label='院校名称：' prop='org_name'>
                    <el-input v-model='form.org_name' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item class='form-item' label='院校Logo：' prop='fileList'>
                    <el-upload
                        class='upload-demo'
                        action='https://up-z2.qiniup.com'
                        :data='uploadData'
                        accept='image/jpeg,image/gif,image/png,image/jpg'
                        :file-list='form.fileList'
                        :limit=1
                        :before-upload='onBeforeUpload'
                        :on-success='onSuccessUpload'
                        :on-remove='onRemoveUpload'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jepg,gif,png,jpg格式的文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item class='form-item' label='院校视频Logo：' prop='videoLogo'>
                    <el-upload
                        class='upload-demo'
                        action='https://up-z2.qiniup.com'
                        :data='uploadData'
                        accept='image/jpeg,image/gif,image/png,image/jpg'
                        :file-list='form.videoLogo'
                        :limit=1
                        :before-upload='onBeforeUpload'
                        :on-success='videoLogoSuccessUpload'
                        :on-remove='onRemoveVideoUpload'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jepg,gif,png,jpg格式的文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item class='form-item' label='PC首页Logo：' prop='PCLogo'>
                    <el-upload
                            class='upload-demo'
                            action='https://up-z2.qiniup.com'
                            :data='uploadData'
                            accept='image/jpeg,image/gif,image/png,image/jpg'
                            :file-list='form.PCLogo'
                            :limit=1
                            :before-upload='onBeforeUpload'
                            :on-success='PCSuccessUpload'
                            :on-remove='onRemovePCUpload'
                            list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jepg,gif,png,jpg格式的文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item class='form-item' label='考前WxLogo：' prop='KQLogo'>
                    <el-upload
                        class='upload-demo'
                        action='https://up-z2.qiniup.com'
                        :data='uploadData'
                        accept='image/jpeg,image/gif,image/png,image/jpg'
                        :file-list='form.KQLogo'
                        :limit=1
                        :before-upload='onBeforeUpload'
                        :on-success='KQSuccessUpload'
                        :on-remove='onRemoveKQUpload'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jepg,gif,png,jpg格式的文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item class='form-item' label='考前PcLogo：' prop='KQPCLogo'>
                    <el-upload
                        class='upload-demo'
                        action='https://up-z2.qiniup.com'
                        :data='uploadData'
                        accept='image/jpeg,image/gif,image/png,image/jpg'
                        :file-list='form.KQPCLogo'
                        :limit=1
                        :before-upload='onBeforeUpload'
                        :on-success='KQPCSuccessUpload'
                        :on-remove='onRemoveKQPCUpload'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jepg,gif,png,jpg格式的文件</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='合作类别：' v-if='org == 1'>
                    <el-select v-model='form.purpose' style='width: 240px'>
                        <el-option v-for='item in purpose' :key='item.value' :value='item.value'
                                   :label='item.label'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='合作机构：' v-if='org == 1'>
                    <el-input v-model='form.organization' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item label='合作联系人：' v-if='org == 1'>
                    <el-input v-model='form.contact' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item label='对接群名称：' v-if='org == 1'>
                    <el-input v-model='form.group_name' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item label='商务负责人：' v-if='org == 1'>
                    <el-input v-model='form.person' style='width: 240px'></el-input>
                </el-form-item>
                <el-form-item label='合作开始日期：' v-if='org == 1'>
                    <el-date-picker
                        :clearable="false"
                        v-model="form.valid_start_time"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label='合作截止日期：' v-if='org == 1'>
                    <el-date-picker
                        :clearable="false"
                        v-model="form.valid_end_time"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='closeDialog'>取 消</el-button>
                <el-button v-if="this.submitStatus === 'add'" type='primary' @click='add()'>确 定</el-button>
                <el-button v-else type='primary' @click='edit()'>确 定</el-button>
            </span>
        </el-dialog>


        <!-- 成绩权重dialog -->
        <el-dialog title='权重' :visible.sync='weightDialog' width='770px' class='weight-dialog'
                   :close-on-click-modal='false' :close-on-press-escape='false'>
            <div class='weight-dialog-title'>成绩权重：</div>
            <el-form :inline='true' :model='weightTableData' class='demo-form-inline'>
                <el-form-item label='视频权重：'>
                    <div class='weight-flex'>
                        <el-input-number v-model='weightData.video_rate' :controls='false' :min='1' :max='99'
                                         class='weight-form' style='width: 70px'></el-input-number>
                        <div class='percentage' style='margin-right: 16px'>%</div>
                    </div>
                </el-form-item>
                <el-form-item label='作业权重：'>
                    <div class='weight-flex'>
                        <el-input-number v-model='weightData.homework_rate' :controls='false' :min='1' :max='99'
                                         class='weight-form' style='width: 70px'></el-input-number>
                        <div class='percentage' style='margin-right: 16px'>%</div>
                    </div>
                </el-form-item>
                <el-form-item label='考试权重：'>
                    <div class='weight-flex'>
                        <el-input-number v-model='weightData.exam_rate' :controls='false' :min='1' :max='99'
                                         class='weight-form' style='width: 70px'></el-input-number>
                        <div class='percentage' style='margin-right: 16px'>%</div>
                    </div>
                </el-form-item>
            </el-form>

            <el-divider></el-divider>
            <div class='weight-dialog-title' v-if='org == 1'>考试规定：</div>
            <el-form :inline='true' :model='weightTableData' class='demo-form-inline' v-if='org == 1'>
                <el-form-item label='视频完成度：'>
                    <div class='weight-flex'>
                        <el-input-number v-model='weightData.exam_video_rate' :controls='false' :min='1' :max='99'
                                         class='weight-form' style='width: 70px'></el-input-number>
                        <div class='percentage' style='margin-right: 16px'>%</div>
                    </div>
                </el-form-item>
                <el-form-item label='作业完成度：'>
                    <div class='weight-flex'>
                        <el-input-number v-model='weightData.exam_homework_rate' :controls='false' :min='1' :max='99'
                                         class='weight-form' style='width: 70px'></el-input-number>
                        <div class='percentage' style='margin-right: 16px'>%</div>
                    </div>
                </el-form-item>
                <el-form-item label='考试时长：'>
                    <div class='weight-flex'>
                        <el-select v-model='weightData.exam_time' class='weight-form weight-select' placeholder=' '>
                            <el-option label='90' value='90'>90</el-option>
                            <el-option label='120' value='120'>120</el-option>
                        </el-select>
                        <div class='percentage' style='margin-right: 16px'>min</div>
                    </div>
                </el-form-item>
            </el-form>


            <span slot='footer' class='dialog-footer'>
                <el-button @click='cancelWeightDialog()'>取消</el-button>
                <el-button type='primary' @click='saveWeight()'>确定</el-button>
            </span>
        </el-dialog>

        <!-- 一键添加测试院校相关信息dialog -->
        <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
                   title="选择该账号的权限" @close='closeInfoDialog'
                   :visible.sync="dialog_visible"
                   width="440px">
            <el-form ref="form" label-position="right" label-width="100px" :rules='rules' :model='addForm'>
                <el-form-item class='form-item' label-width='120px' label='账号：' prop='account'>
                    <el-input class='page-input' placeholder='请输入账号'
                              v-model='addForm.account'></el-input>
                </el-form-item>
                <el-form-item class='form-item' label-width='120px' label='密码：' prop='password'>
                    <el-input type='password' placeholder='请输入密码' class='page-input' v-model='addForm.password'></el-input>
                </el-form-item>
                <el-form-item label="权限：">
                    <el-tree
                        :data="menu_list"
                        show-checkbox
                        node-key="id"
                        ref="tree"
                        highlight-current
                        :props="defaultProps">
                    </el-tree>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeInfoDialog">取 消</el-button>
                <el-button type="primary" @click="addOrgInfo()" style="margin-left: 16px">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'collegeManagement',
    data() {
        return {
            addForm:{
                account:null,
                password:null,
            },
            curOrg:0,
            dialog_visible:false,
            menu_list: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            purpose: [],
            purposeHash: [],
            uploadData: {
                key: '',
                token: ''
            },
            weightDialog: false,
            weightTableData: {},
            weightData: {
                video_rate: 0,
                homework_rate: 0,
                exam_rate: 0,
                exam_video_rate: 0,
                exam_homework_rate: 0,
                exam_time: 0,
                org: 0
            },
            dialogVisible: false,
            dialogTitle: '',
            submitStatus: '',
            tableData: [],
            searchData: '',
            form: {
                org: 0,
                org_code: 0,
                org_name: '',
                fileList: [],
                videoLogo: [],
                PCLogo: [],
                KQLogo:[],
                KQPCLogo:[],
                purpose: '', //合作类别
                organization: '', //合作机构
                person: '', //商务负责人
                contact:'', //合作联系人
                group_name:'',  //群名称
                valid_end_time:'',  //合作截止时间
                valid_start_time:'' //合作开始时间
            },
            listQuery: {
                'content': '', //院校名称/院校代码
                'purpose': '', //合作类别
                'organization': '', //合作机构
                'person': '', //商务负责人
                'pageIndex': 1,
                'pageTotal': 0,
                'pageSize': 10,
            },
            rules: {
                account: [
                    { required: true, message: '请输入账号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                org_name: [
                    { type: 'string', required: true, message: '请输入院校名称', trigger: 'blur' }, {
                        min: 1, max: 32, message: '院校名称长度在1 - 32之间'
                    }
                ],
                org_code: [
                    { required: true, message: '请输入院校代码！', trigger: 'blur' }
                ],
                org_id: [
                    { type: 'number', required: true, message: '请输入院校ID', trigger: 'blur' }
                ]

            },
            imgData: [],
            org:0
        };
    },
    created() {
        this.org = localStorage.getItem('org');
        this.getData();
        this.getTransitionValue();
        this.getMenuList()
    },
    methods: {
        // 查看进度
        openProcess() {
            this.$router.push({ path: '/task' });
        },
        addInfo(org){
            this.curOrg = org
            this.dialog_visible=true
        },
        // 一键添加测试院校功能
        addOrgInfo() {
            let that = this
            let menu_list = this.$refs.tree.getCheckedKeys()
            let parent_id = this.$refs.tree.getHalfCheckedKeys()

            if (this.addForm.account == null || this.addForm.account.length > 20 || this.addForm.account.length < 6){
                this.$message.error("账号只能为6-20位")
                return
            }
            if (this.addForm.password == null || this.addForm.password.length == 0){
                this.$message.error("密码不能为空")
                return
            }
            if (menu_list.length == 0){
                this.$message.error("权限列表不能为空。")
                return
            }
            this.$post(this.BASEURL + `/academy/add/account/test`, {
                'menu_list': menu_list,
                'half_list':parent_id,
                'account':this.addForm.account,
                'password':this.addForm.password,
                'org': this.curOrg
            }).then((res) => {
                if (res.code == 200) {
                    that.$message.success(res.msg)
                    that.dialog_visible = false
                    that.$refs.tree.setCheckedKeys([])
                } else {
                    that.$message.error(res.error);
                }
            });
        },
        closeInfoDialog() {
            this.dialog_visible = false
            this.$refs.tree.setCheckedKeys([])
        },
        getMenuList(){
            console.log('org:-------------------------------->',this.org)
            if (this.org!=1){
                let base64_str = window.localStorage.getItem("role_menu_tree")
                let role_menu_tree = this.$base64.decode(base64_str)
                this.menu_list = JSON.parse(role_menu_tree)
            }else{
                this.$get(
                    this.BASEURL + `/permission/menu/GET`).then((res) => {
                    if (res.code === 200) {
                        this.menu_list = res.data
                        console.log('this.menu_list',this.menu_list);
                    } else {
                        this.$message.error(res.error);
                    }
                });
            }
        },
        getTransitionValue() {
            let data = ['academy_purpose'];
            this.$post(this.BASEURL + '/assets/transition/GET', {
                key_list: data
            }).then((res) => {
                if (res.code === 200) {
                    this.purpose = res.data.academy_purpose[0];
                    this.purposeHash = res.data.academy_purpose[1];
                } else {
                    console.log(res.error);
                }
            });
        },
        saveWeight() {
            if (this.weightData.video_rate + this.weightData.homework_rate + this.weightData.exam_rate !== 100) {
                this.$message.error('权重总数不等于100,请重新设置！');
                return false;
            }
            let data = {
                org: this.weightData.org,
                video_rate: this.weightData.video_rate,
                homework_rate: this.weightData.homework_rate,
                exam_rate: this.weightData.exam_rate,
                exam_video_rate: this.weightData.exam_video_rate,
                exam_homework_rate: this.weightData.exam_homework_rate,
                exam_time: this.weightData.exam_time
            };
            this.$put(
                this.BASEURL + '/academy/rate/modify', data).then((res) => {
                if (res.code == 200) {
                    this.weightDialog = false;
                    this.getData();
                    this.$message.success('编辑成功！');
                } else {
                    this.$message.error(res.error);
                }
            });

        },
        openWeightDialog(data) {
            this.weightTableData[0] = data;
            this.weightData = {
                video_rate: data.video_rate,
                homework_rate: data.homework_rate,
                exam_rate: data.exam_rate,
                exam_video_rate: data.exam_video_rate,
                exam_homework_rate: data.exam_homework_rate,
                exam_time: data.exam_time,
                org: data.org
            },

                this.weightDialog = true;
        },
        cancelWeightDialog() {
            this.weightDialog = false;
        },
        getData() {
            this.$get(this.BASEURL + `/academy/management?page=${this.listQuery.pageIndex}&content=${this.listQuery.content}&purpose=${this.listQuery.purpose}&organization=${this.listQuery.organization}&person=${this.listQuery.person}`).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.data;
                    this.listQuery.pageTotal = res.total;
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        reset() {
            this.listQuery={
                    'content': '', //院校名称/院校代码
                    'purpose': '', //合作类别
                    'organization': '', //合作机构
                    'person': '', //商务负责人
                    'pageIndex': 1,
                    'pageTotal': 0,
                    'pageSize': 10,
            },
            this.getData();
        },
        // // 触发搜索按钮
        handleSearch() {
            this.listQuery.pageIndex = 1;
            this.getData();
        },
        judgeBtn(status, form) {
            this.submitStatus = status;
            if (status === 'add') {
                this.dialogTitle = '添加院校';
                this.form = {
                    org: 0,
                    org_code: '',
                    org_name: '',
                    fileList: [],
                    videoLogo: [],
                    PCLogo: [],
                    KQLogo: [],
                    KQPCLogo:[],
                    purpose: '',
                    organization:'',
                    person:'',
                    contact:'',
                    group_name:'',
                    valid_start_time:'',
                    valid_end_time:''
                };
                this.dialogVisible = true;
            } else if (status === 'edit') {
                this.form = JSON.parse(JSON.stringify(form));
                if(form.img_url !== '' && form.img_url !== undefined && form.img_url !== null){
                    this.form.fileList = [
                        {
                            'url': form.img_url,
                            'name': form.img_name
                        }
                    ];
                }
                if(form.logo_url !== '' && form.logo_url !== undefined && form.logo_url !== null){
                    this.form.videoLogo = [
                        {
                            'url': form.logo_url,
                            'name': form.logo_name
                        }
                    ];
                }
                if(form.pc_url !== '' && form.pc_url !== undefined && form.pc_url !== null){
                    this.form.PCLogo = [
                        {
                            'url': form.pc_url,
                            'name': form.pc_name,
                        }
                    ];
                }
                if(form.kqfd_url !== '' && form.kqfd_url !== undefined && form.kqfd_url !== null){
                    this.form.KQLogo = [
                        {
                            'url': form.kqfd_url,
                            'name': form.kqfd_name,
                        }
                    ];
                }
                if(form.kqpcfd_url !== '' && form.kqpcfd_url !== undefined && form.kqpcfd_url !== null){
                    this.form.KQPCLogo = [
                        {
                            'url': form.kqpcfd_url,
                            'name': form.kqfd_name,
                        }
                    ];
                }
                this.dialogTitle = '编辑院校';
                this.dialogVisible = true;
            }
        },
        add() {
            let validStatus;
            this.$refs['form'].validate((valid) => {
                validStatus = valid;
            });
            if (!validStatus) {
                this.$message.error('请您检查必填项');
                return;
            }
            this.form.org_code = parseInt(this.form.org_code);
            if (window.isNaN(this.form.org_code)) {
                this.$message.error('院校代码输入错误，请输入数字');
                return;
            }
            // if (this.form.fileList.length === 0) {
            //     this.$message.error('请您上传“院校Logo”');
            //     return;
            // }
            // if (this.form.videoLogo.length === 0) {
            //     this.$message.error('请您上传“院校视频Logo”');
            //     return;
            // }

            if (this.form.fileList.length=== 0) {
                this.form.fileList = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.PCLogo.length=== 0) {
                this.form.PCLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.videoLogo.length=== 0) {
                this.form.videoLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.KQLogo.length=== 0) {
                this.form.KQLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.KQPCLogo.length=== 0) {
                this.form.KQPCLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            this.form.org_code = parseInt(this.form.org_code);
            let data = {
                'org': this.form.org,
                'org_code': this.form.org_code,
                'org_name': this.form.org_name,
                'img_name': this.form.fileList[0].name,
                'img_url': this.form.fileList[0].url,
                'logo_url': this.form.videoLogo[0].url,
                'logo_name': this.form.videoLogo[0].name,
                'pc_url': this.form.PCLogo[0].url,
                'pc_name': this.form.PCLogo[0].name,
                'kqfd_url': this.form.KQLogo[0].url,
                'kqpcfd_url': this.form.KQPCLogo[0].url,
                'purpose': this.form.purpose,
                'balance': 0,
                'price': 1,
                'organization':this.form.organization,
                'person':this.form.person,
                'contact':this.form.contact, //合作联系人
                'group_name':this.form.group_name,  //群名称
                'valid_start_time':this.form.valid_start_time,
                'valid_end_time':this.form.valid_end_time
            };

            this.$post(
                this.BASEURL + '/academy/management', data).then((res) => {
                if (res.code == 200) {
                    this.getData();
                    this.$message.success('添加成功！');
                    this.dialogVisible = false;
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        edit() {
            let validStatus;
            this.$refs['form'].validate((valid) => {
                validStatus = valid;
            });
            if (!validStatus) {
                this.$message.error('请您检查必填项');
                return;
            }
            // if (this.form.fileList.length === 0) {
            //     this.$message.error('请您上传“院校Logo”');
            //     return;
            // }
            // if (this.form.videoLogo.length === 0) {
            //     this.$message.error('请您上传“院校视频Logo”');
            //     return;
            // }
            this.form.org_code = parseInt(this.form.org_code);
            if (window.isNaN(this.form.org_code)) {
                this.$message.error('院校代码输入错误，请输入数字');
                return;
            }

            if (this.form.PCLogo == undefined) {
                this.form.PCLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.videoLogo == undefined) {
                this.form.videoLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.KQLogo == undefined) {
                this.form.KQLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }
            if (this.form.KQPCLogo == undefined) {
                this.form.KQPCLogo = [
                    {
                        'url': '',
                        'name': '',
                    }
                ];
            }

            let data = {
                'id': this.form.id,
                'org': this.form.org,
                'org_code': this.form.org_code,
                'org_name': this.form.org_name,
                'img_name': this.form.fileList[0].name,
                'img_url': this.form.fileList[0].url,
                'logo_url': this.form.videoLogo[0].url,
                'logo_name': this.form.videoLogo[0].name,
                'pc_url': this.form.PCLogo[0].url,
                'pc_name': this.form.PCLogo[0].name,
                'kqfd_url': this.form.KQLogo[0].url,
                'kqpcfd_url': this.form.KQPCLogo[0].url,
                'purpose': this.form.purpose,
                'balance': 0,
                'price': 1,
                'organization':this.form.organization,
                'person':this.form.person,
                'contact':this.form.contact, //合作联系人
                'group_name':this.form.group_name,  //群名称
                'valid_start_time':this.form.valid_start_time,
                'valid_end_time':this.form.valid_end_time
            };

            this.$put(
                this.BASEURL + '/academy/management', data).then((res) => {
                if (res.code == 200) {
                    this.getData();
                    this.$message.success('编辑成功！');
                    this.dialogVisible = false;
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        del(id) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$del(
                    this.BASEURL + `/academy/management?id=${id}`).then((res) => {
                    if (res.code == 200) {
                        this.getData();

                        this.$message.success('删除成功！');
                    } else {
                        this.$message.error(res.error);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        closeDialog() {
            this.dialogVisible = false;
        },
        // 分页导航
        handlePageChange(val) {
            this.listQuery.pageIndex = val;
            this.getData();
        },
        onBeforeUpload(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/gif' && file.type !== 'image/png' && file.type !== 'image/jpg') {
                this.$message.error('上传文件只能是规定的图片格式!');
                return false;
            }

            return (new Promise((resolve, reject) => {
                // 获取七牛云token
                this.$get(this.BASEURL + `/assets/qiniupng/token/GET`).then((res) => {
                    if (res.code == 200) {
                        this.uploadData.token = res.token;
                        this.uploadData.key = res.key;
                        resolve();
                    }
                });
            }));
        },
        onSuccessUpload(response, file, fileList) {
            this.form.fileList = [
                {
                    'url': 'http://c.zikaoj.com/' + response.key,
                    'name': 'qiniuyun'
                }
            ];
        },
        videoLogoSuccessUpload(response, file, fileList) {
            this.form.videoLogo = [
                {
                    'url': 'http://c.zikaoj.com/' + response.key,
                    'name': 'qiniuyun'
                }
            ];
        },
        PCSuccessUpload(response, file, fileList){
            this.form.PCLogo = [
                {
                    'url': 'http://c.zikaoj.com/' + response.key,
                    'name': 'qiniuyun'
                }
            ];
        },
        KQSuccessUpload(response, file, fileList){
            this.form.KQLogo = [
                {
                    'url': 'http://c.zikaoj.com/' + response.key,
                    'name': 'qiniuyun'
                }
            ];
        },
        KQPCSuccessUpload(response, file, fileList){
            this.form.KQPCLogo = [
                {
                    'url': 'http://c.zikaoj.com/' + response.key,
                    'name': 'qiniuyun'
                }
            ];
        },
        onRemoveVideoUpload(file, fileList) {
            this.form.videoLogo = [];
        },
        onRemoveUpload(file, fileList) {
            this.form.fileList = [];
        },
        onRemovePCUpload(file, fileList) {
            this.form.PCLogo = [];
        },
        onRemoveKQUpload(file, fileList) {
            this.form.KQLogo = [];
        },
        onRemoveKQPCUpload(file, fileList) {
            this.form.KQPCLogo = [];
        },
        open() {
            this.$message.warning('暂未开放!');

        }

    }
};
</script>

<style lang='scss' scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

/deep/ .weight-form .el-input .el-input__inner {
    border-radius: 5px 0 0 5px
}

/deep/ .cell .el-input-number .el-input__inner {
    width: 70px;
    /*border-right: none;*/
    /*border-radius: 5px 0 0 5px;*/
}

.weight-flex {
    display: flex;

    .weight-select {
        width: 70px;
    }
}

.percentage {
    background-color: #F5F7FA;
    text-align: center;
    line-height: 30px;
    height: 30px;
    width: 30px;
    color: #999999;
    border: 1px solid #DCDFE6;
    border-radius: 0 5px 5px 0;
    border-left: none;
}

.table-cls {
    margin-top: 28px;
}

.weight-box {
    margin-left: 46px;
    display: flex;

    .percent {
        margin-left: -30px;
        text-align: center;
        line-height: 32px;
    }
}

.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;

    .search-input {
        width: 240px;
        margin-right: 10px;
    }

    .title {
        font-size: $title-size;
        line-height: 15px;
        color: #343434;
    }
}

.primary-btn {
    border-color: #409EFF;
    color: #409EFF;
}

.handle-box {
    text-align: right;
    margin-right: 20px;
    display: flex;

    .search {
        display: flex;
    }
}

.weight-dialog {
    ::v-deep .el-form-item label {
        width: 100px;
    }

    .weight-dialog-title {
        color: #343434;
        line-height: 30px;
        font-size: 16px;
        font-weight: 700;
    }
}
</style>
